import React, { Fragment, useEffect, useState } from "react";
import { SolidButton } from "../../../global/SolidButton";
import {
  CalendarDays,
  Check,
  CircleCheckBig,
  CircleDollarSign,
  Plus,
  Trash2,
  X,
} from "lucide-react";

import { PencilSimpleLine } from "phosphor-react";
import toast, { Toaster } from "react-hot-toast";
import { MyModal } from "../../../global/MyModal";

import {
  addBonus,
  deleteBonus,
  getBonus,
  updateBonus,
  updateBonusStatus,
} from "../api";
import MyLoader from "../../../util/MyLoader";
import Pagination from "../../../util/Pagination";
import { BorderButton } from "../../../global/BorderButton";
import { useNavigate, useParams } from "react-router-dom";

export default function BonusSetting() {
  const [activeTab, setActiveTab] = useState(1);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [isEditMode, setIsEditMode] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  const [bonuses, setBonuses] = useState([]);
  // pagination states
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);

  //form
  const [eventType, setEventType] = useState(null);
  const [coinAmount, setCoinAmount] = useState(0);
  const [repeatCount, setRepeatCount] = useState(1);
  const [title, setTitle] = useState(null);
  const [transMessage, setTransMessage] = useState("");
  const [enableCoinVariation, setEnableCoinVariation] = useState(false);
  const [errors, setErrors] = useState({});
  const [isDisabled, setDisabled] = useState(false);
  const [currentBonusId, setCurrentBonusId] = useState(null);

  const { id } = useParams();
  const navigate = useNavigate();

  const type = [
    //  { id: 1, label: "All Bonus" },
    { id: 0, label: "All", value: "all" },
    { id: 1, label: "Active", value: "active" },
    { id: 2, label: "Inactive", value: "inactive" },
  ];

  const handleTabClick = (tabId) => {
    const selectedTab = type.find((item) => item.id === tabId);

    if (!selectedTab) return;

    navigate(`/apps/${id}/settings/bonus?status=${selectedTab.value}`);
    setActiveTab(tabId);
  };
  const validateForm = () => {
    const errs = {};
    //event type validation
    if (!eventType || !eventType.trim()) {
      errs.eventType = "Event Type is required";
    }
    //coin amount validation
    if (coinAmount <= 0 || isNaN(Number(coinAmount))) {
      errs.coinAmount = "Coin must be greater than zero";
    }
    //bonus title validation
    if (!title || !title.trim()) {
      errs.bonusTitle = "Bonus Title is required";
    }
    //transaction message validation
    if (!transMessage || !transMessage.trim()) {
      errs.transMessage = "Transaction Message is required";
    }

    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const handleSubmit = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    if (!validateForm()) return;

    const payload = {
      event: eventType.trim(),
      title: title.trim(),
      coins: Number(coinAmount),
      repeat: Number(repeatCount),
      variation: enableCoinVariation ? 1 : 0,

      tnx_message: transMessage.trim(),
    };
    const addNewBonus = async () => {
      try {
        setDisabled(true);
        const dataRes = isEditMode
          ? await updateBonus(currentBonusId, payload)
          : await addBonus(payload);

        if (dataRes.status === 200 || dataRes.status === 201) {
          // refresh list
          fetchBonuses();
          toast.success(
            isEditMode
              ? "Bonus updated successfully"
              : "Bonus added successfully",
          );

         

          // close modal and reset
          setIsModalOpen(false);

          setEventType(null);
          setCoinAmount(null);
          setTitle(null);
          setTransMessage("");

          setErrors({});
          setDisabled(false);
        }
      } catch (err) {
        setDisabled(false);
        console.error("Failed to add bonus", err);
        // show error toast
      }
    };
    addNewBonus();
  };

  const fetchBonuses = async () => {
    try {
      const res = await getBonus({
        page: page,
        limit: limit,
        search: search,
        status: activeTab === 1 ? "active" : "inactive",
      });

      setBonuses(res.data?.bonuses || []); // ✅ THIS LINE
      setTotal(res.data?.totalRows || 0); // ✅ FIX
    } catch (err) {
      console.error("Failed to fetch apps", err);
    } finally {
      setLoading(false);
    }
  };

  const handleStatus = async (data) => {
    try {
      const payload = {
        active: !data.active,
      };
      const dataRes = await updateBonusStatus(data.id, payload);
      if (dataRes.status === 200) {
        // refresh list
        fetchBonuses();
        toast.success("Status updated successfully");
      }
    } catch (err) {
      setDisabled(false);
      console.error("Failed to add bonus", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      fetchBonuses();
    }, 400);

    return () => clearTimeout(timer);
  }, [page, limit, search, activeTab]);

  // ------------------------------
  // OPEN ADD MODAL
  // ------------------------------
  const openAddModal = () => {
    setIsEditMode(false);

    // reset form when opening add modal
    setEventType(null);
    setCoinAmount(0);
    setTitle(null);
    setTransMessage("");
    setRepeatCount(1);
    setErrors({});

    setIsModalOpen(true);
  };

  // ------------------------------
  // OPEN EDIT MODAL
  // ------------------------------
  const openEditModal = (bonus) => {
    setIsEditMode(true);
    setIsModalOpen(true);
    setCurrentBonusId(bonus.id);
    handleUpdate(bonus);
  };

  // Update
  const handleUpdate = (data) => {
    //if(!currentAppConfig)return;

    // fill form
    setEventType(data.event);
    setTitle(data.title);
    setCoinAmount(data.coins);
    setRepeatCount(data.repeat)
    setEnableCoinVariation(data.variation === 1);
    setTransMessage(data.tnx_message);
  };

  // ------------------------------
  // DELETE CONFIG
  // ------------------------------
  const handleDelete = async () => {
    try {
      const res = await deleteBonus(deleteId);
      if (res.status === 200) {
        toast.success("Bonus deleted successfully");
        // refresh list
        fetchBonuses();
      }
    } catch (err) {
      console.error("Failed to delete configuration", err);
      toast.error(err.response?.data?.error || "Failed to delete config");
    }
    setDeleteId(null);
  };

  //Search
  useEffect(() => {
    const timer = setTimeout(() => {
      setPage(1);
    }, 400);

    return () => clearTimeout(timer);
  }, [search]);

  if (loading) return <MyLoader />;

  return (
    <Fragment>
      <div className="space-y-2 h-screen relative  ">
        <div className="flex flex-row items-center justify-start space-x-4">
          {/* tabs */}
          <div
            className=" py-2 p-2 bg-slate-300/25 dark:bg-gray-700/30 backdrop-blur-xl rounded-lg   
              "
          >
            {type.map((tab) => (
              <button
                key={tab.id}
                onClick={() => handleTabClick(tab.id)}
                className={` text-xs border 
                 mr-2
           p-1 rounded-sm transition-all duration-200 transform
           text-slate-800 dark:text-slate-300 font-normal ${
             tab.id === activeTab
               ? "bg-white dark:bg-slate-100/2 border dark:via-slate-800 dark:to-slate-900 border-slate-300"
               : "border-transparent cursor-pointer"
           }`}
              >
                {tab.label}
              </button>
            ))}
          </div>

          {/* search */}
          <div>
            <input
              type="text"
              placeholder="Search bonus"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="w-[250px]  text-xs py-2.5 px-4 bg-slate-400/20 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-xl text-slate-800 dark:text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all"
            />
          </div>
          <div className="ml-auto">
            <SolidButton
              onClick={() => openAddModal()}
              children={
                <>
                  <Plus className="w-4 h-4" />
                  <span>Add Bonus</span>
                </>
              }
            />
          </div>
        </div>
        {/* table */}
        <div
          className="bg-white/80 dark:bg-slate-900/80
               backdrop-blur-xl rounded-2xl  
               border border-state-200/50 dark:border-slate-700/50 
                w-full 
                pb-4
                
               overflow-x-auto
               
                      
              
              "
        >
          <table className="min-w-full border-collapse ">
            <thead>
              <tr className="bg-slate-100 dark:bg-slate-800/60 border-t border-slate-300 dark:border-slate-700">
                <th className="text-start text-xs font-semibold text-slate-600 dark:text-slate-400 ps-4 py-3 ">
                  Event
                </th>
                <th className="text-start  text-xs font-semibold text-slate-600 dark:text-slate-400 py-3">
                  Coin
                </th>
                <th className="text-start text-xs font-semibold text-slate-600 dark:text-slate-400 py-3">
                  Repeat
                </th>
                <th className="text-start text-xs font-semibold text-slate-600 dark:text-slate-400 py-3">
                  Variation
                </th>
                <th className="text-start text-xs font-semibold text-slate-600 dark:text-slate-400 py-3">
                  Active
                </th>
                <th className="text-start text-xs font-semibold text-slate-600 dark:text-slate-400 py-3 ">
                  DateTime
                </th>
                <th className="text-end text-xs font-semibold text-slate-600 dark:text-slate-400 py-3 pe-4">
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {bonuses.map((bonus, index) => (
                <tr
                  key={index}
                  className="hover:bg-slate-100 dark:hover:bg-gray-800/20 border-b border-slate-300/40"
                >
                  <td className="text-start  py-4 ps-4">
                    <div className="flex items-center justify-start space-x-2">
                      <div className="flex flex-col justify-start">
                        <h1 className="text-[11px] font-medium text-slate-900 dark:text-slate-200">
                          {bonus.title}
                        </h1>
                        <p className="text-[11px] font-normal text-slate-500 dark:text-slate-400">
                          {`#${bonus.id}-${bonus.tnx_message}`}
                        </p>
                      </div>
                    </div>
                  </td>
                  <td className="text-start py-4">
                    <div className="flex flex-row space-x-1 items-center justify-start">
                      <CircleDollarSign className="w-4 h-4 text-amber-500" />
                      <span className="text-xs font-mono text-slate-900 dark:text-slate-200">
                        {bonus.coins}
                      </span>
                    </div>
                  </td>
                  <td className="text-start uppercase text-xs font-medium text-slate-900 dark:text-slate-200 py-4 ">
                    {bonus.repeat}
                  </td>

                  <td className="text-start">
                    <div className="flex items-center justify-start">
                      {bonus.variation === 1 ? (
                        <>
                          <CircleCheckBig className=" w-4 h-4 text-green-500 " />
                        </>
                      ) : (
                        <>
                          <X className="w-4 h-4 text-red-500" />
                        </>
                      )}
                    </div>
                  </td>
                  <td className="text-start">
                    <div className="flex items-center justify-start ">
                      <Check
                        onClick={() => {
                          handleStatus(bonus);
                        }}
                        strokeWidth={4}
                        className={`w-[20px] h-[20px] cursor-pointer p-1 rounded-md border border-slate-400 ${
                          bonus.active
                            ? "bg-blue-500 text-white"
                            : "text-white/0"
                        } `}
                      />
                    </div>
                  </td>
                  <td className="text-start font-normal text-slate-500 dark:text-slate-400 ">
                    <div className="flex items-center justify-start space-x-1">
                      <CalendarDays size={12} />
                      <span className="text-[11px]  font-sans">
                        {formatDateTime(bonus.date_time)}
                      </span>
                    </div>
                  </td>
                  <td className="text-end">
                    <div className="flex items-center justify-end space-x-4  pe-4">
                      <PencilSimpleLine
                        className="w-6 h-6 text-slate-800 dark:text-slate-200 border border-slate-200 rounded-sm p-1 cursor-pointer"
                        weight="light"
                        onClick={() => openEditModal(bonus)}
                      />
                      <Trash2
                        className="w-6 h-6 text-red-400 border border-slate-200 rounded-sm p-1 cursor-pointer"
                        onClick={() => setDeleteId(bonus.id)}
                      />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="w-full b-0 absolute">
          <Pagination
            page={page}
            limit={limit}
            total={total}
            fixed={false}
            onPageChange={setPage}
            onLimitChange={(l) => {
              setLimit(l);
              setPage(1); // reset to first page
            }}
            constrainTo="#devices-main"
          />
        </div>
      </div>
      {/* ADD / EDIT MODAL */}
      <MyModal
        isOpen={isModalOpen}
        title={isEditMode ? "Update Bonus" : "Add New Bonus"}
        onClose={() => setIsModalOpen(false)}
        width="560px"
      >
        <div className="w-full space-y-4 mt-4">
          {/* Event Type */}
          <div>
            <label className="block text-xs font-medium text-slate-500 mb-1">
              Event Type*
            </label>
            <input
              type="text"
              placeholder="e.g.,spin,dailybonus,slotspin"
              value={eventType}
              onChange={(e) => {
                setEventType(e.target.value);
                if (errors.eventType)
                  setErrors((prev) => ({ ...prev, eventType: undefined }));
              }}
              aria-invalid={!!errors.eventType}
              className={`w-full text-xs py-2.5 px-4 bg-slate-400/20 dark:bg-slate-800 border rounded-xl text-slate-800 dark:text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all ${
                errors.eventType
                  ? "border-red-400"
                  : "border-slate-200 dark:border-slate-700"
              }`}
            />

            {errors.eventType && (
              <div className="text-xs text-red-500 mt-1">{errors.name}</div>
            )}
          </div>
          {/* coins and repeat */}
          <div className="flex  items-start justify-between space-x-12   w-full">
            {/* coin amount */}
            <div className="flex flex-col  md:w-1/2">
              <label className="block text-xs font-medium text-slate-500 mb-1">
                Coin Amount*
              </label>
              <input
                type="number"
                placeholder="e.g.,100,500,1000"
                value={coinAmount}
                onChange={(e) => {
                  setCoinAmount(e.target.value);
                  if (errors.coinAmount)
                    setErrors((prev) => ({ ...prev, coinAmount: undefined }));
                }}
                aria-invalid={!!errors.coinAmount}
                className={`w-full text-xs py-2.5 px-4 bg-slate-400/20 dark:bg-slate-800 border rounded-xl text-slate-800 dark:text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all ${
                  errors.coinAmount
                    ? "border-red-400"
                    : "border-slate-200 dark:border-slate-700"
                }`}
              />
              <p className="text-[10px] text-gray-500 dark:text-slate-400 font-semibold mt-1">
                Base coin amount (can vary if variation is enabled)
              </p>
            </div>
            {/* Repeat Count */}
            <div className="flex flex-col  md:w-1/2">
              <label className="block text-xs font-medium text-slate-500 mb-1">
                Repeat Count*
              </label>
              <input
                type="number"
                placeholder="e.g.,100,500,1000"
                name="repeatCount"
                value={repeatCount}
                min={1}
                onChange={(e) => {
                  setRepeatCount(e.target.value);
                }}
                aria-invalid={!!errors.repeatCount}
                className={`w-full text-xs py-2.5 px-4 bg-slate-400/20 dark:bg-slate-800 border rounded-xl text-slate-800 dark:text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all ${
                  errors.repeatCount
                    ? "border-red-400"
                    : "border-slate-200 dark:border-slate-700"
                }`}
              />
              <p className="text-[10px] text-gray-500 dark:text-slate-400 font-semibold mt-1">
                How many times this bonus can be claimed
              </p>
            </div>
          </div>
          {/* Bonus Title */}
          <div>
            <label className="block text-xs font-medium text-slate-500 mb-1">
              Bonus Title*
            </label>
            <input
              type="text"
              name="bonusTitle"
              placeholder="e.g.,Daily Login Bonus,Lucky Spin Wheel"
              value={title}
              onChange={(e) => {
                setTitle(e.target.value);
                if (errors.title)
                  setErrors((prev) => ({ ...prev, title: undefined }));
              }}
              aria-invalid={!!errors.title}
              className={`w-full text-xs py-2.5 px-4 bg-slate-400/20 dark:bg-slate-800 border rounded-xl text-slate-800 dark:text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all ${
                errors.title
                  ? "border-red-400"
                  : "border-slate-200 dark:border-slate-700"
              }`}
            />

            {errors.title && (
              <div className="text-xs text-red-500 mt-1">{errors.title}</div>
            )}
            <p className="text-[10px] text-gray-500 dark:text-slate-400 font-semibold mt-1">
              Display name for this Bonus
            </p>
          </div>
          {/* Transaction Message */}
          <div className="mt-4">
            <label className="block text-xs font-medium text-slate-500 mb-1">
              Transaction Message*
            </label>
            <textarea
              type="text"
              name="message"
              placeholder="e.g.,Congratulations! You've recieved your daily bonus!"
              value={transMessage}
              onChange={(e) => {
                setTransMessage(e.target.value);
                if (errors.transMessage)
                  setErrors((prev) => ({ ...prev, transMessage: undefined }));
              }}
              aria-invalid={!!errors.transMessage}
              className={`w-full h-20 text-xs py-2.5 px-4 bg-slate-400/20 dark:bg-slate-800 border rounded-xl text-slate-800 dark:text-white placeholder-slate-500 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all ${
                errors.transMessage
                  ? "border-red-400"
                  : "border-slate-200 dark:border-slate-700"
              }`}
            />
            {errors.transMessage && (
              <div className="text-xs text-red-500 mt-1">
                {errors.transMessage}
              </div>
            )}
          </div>

          {/* Enable Coin Variation */}
          <div className="space-x-2 p-2 flex items-start justify-start rounded-lg bg-slate-300/30 dark:bg-slate-200/10 border border-slate-300 dark:border-slate-700">
            <input
              className="w-8 h-8 rounded-2xl p-0 flex items-start justify-start"
              type="checkbox"
              name="enableCoinVariation"
              checked={enableCoinVariation}
              value={enableCoinVariation}
              onChange={() => setEnableCoinVariation((prev) => !prev)}
            />

            <div className="flex flex-col items-start justify-start ">
              <h1 className="text-start text-xs  text-slate-800 dark:text-slate-200 font-bold">
                Enable Coin Variation
              </h1>
              <p className="text-start text-[12px]  text-slate-700 dark:text-slate-400 font-normal">
                When enabled, the actual coin amount will vary randomly around
                the base amount. Perfect for spin wheels and mystery boxes to
                create excitement.
              </p>
            </div>
          </div>
          <div className="bg-slate-300 dark:bg-slate-700 h-[1px] mt-4" />

          {/* action buttons */}
          <div className="flex space-x-4 justify-end mt-6">
            <BorderButton onClick={() => setIsModalOpen(false)}>
              <span className="text-sm text-slate-400">Cancel</span>
            </BorderButton>
            <SolidButton
              disabled={isDisabled}
              className="px-4 py-2 text-sm space-x-2"
              onClick={() => handleSubmit()}
            >
              {isEditMode ? "Update Bonus" : "Create Bonus"}
            </SolidButton>
          </div>
        </div>
      </MyModal>
      {/* DELETE CONFIRM MODAL */}
      <MyModal
        isOpen={!!deleteId}
        title="Delete Config?"
        onClose={() => setDeleteId(null)}
      >
        <p className="text-sm text-slate-800 dark:text-slate-300 mt-4">
          Are you sure you want to delete this config?
        </p>

        <div className="flex justify-end space-x-3 mt-6">
          <button
            onClick={() => setDeleteId(null)}
            className="px-4 py-2 rounded-lg bg-slate-400/20 dark:bg-slate-800 text-sm"
          >
            Cancel
          </button>

          <SolidButton onClick={handleDelete} children={<span>Delete</span>} />
        </div>
      </MyModal>
    </Fragment>
  );
}

function formatDateTime(dateString) {
  if (!dateString) return "-";

  const date = new Date(dateString);

  // ✅ prevent RangeError
  if (isNaN(date.getTime())) return "-";

  return new Intl.DateTimeFormat("en-US", {
    month: "short",
    day: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  }).format(date);
}
